import { Box, Dialog, Paper } from '@material-ui/core';
import React, { FC, useState } from 'react';
import closeButton from 'src/images/close-button.png';
import codeImg from 'src/images/code-img.png';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import InstructionModal from './InstructionModal';
import copy from 'src/images/GET_CODE_IMAGE.webp';
import copied from 'src/images/GET_CODE_COPIED_IMAGE.webp';
interface GetCodeModalProps {
  handleClose: React.MouseEventHandler<HTMLButtonElement>;
  getCode?: any;
}

const GetCodeModal: FC<GetCodeModalProps> = props => {
  const code = props.getCode;
  const front = code?.[0];
  const body = code?.[1];
  const back = code?.[2];

  const obfuscation = `
  <html> 
    <meta charSet="UTF-8"/>
      <head>
        <script src="https://code.jquery.com/jquery-2.2.0.min.js"></script>
        <script src="https://cdn.jsdelivr.net/npm/js-base64@3.6.1/base64.min.js"></script>
        <script src="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.js"></script>
        <script src="https://cdnjs.cloudflare.com/ajax/libs/jquery.countdown/2.2.0/jquery.countdown.min.js"></script>                
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" />
        <link
          href="https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
         <link
          href="https://fonts.googleapis.com/css2?family=Archivo:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
         rel="stylesheet"
         as="style"
         crossorigin
         href="https://cdn.jsdelivr.net/gh/orioncactus/pretendard@v1.3.9/dist/web/static/pretendard.min.css"
       />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://cdn.jsdelivr.net/npm/normalize.css@8.0.1/normalize.css"
        />      
      </head>
    <script>
      document.write(Base64.decode('${front}') + \`${body}\` + Base64.decode('${back}'));
    </script> 
    <a href="appboy://close"></a>
  </html>`;

  const [backgroundColor, setBackgroundColor] = useState('#f5f5f5');
  const [textColor, setTextColor] = useState('#000000');
  const [codeCopy, setCodeCopy] = useState(false);
  const [instructionOpen, setInstructionOpen] = useState(false);

  const handleClick = () => {
    setBackgroundColor('#f2f6ff');
    setTextColor('#346aff');
    setCodeCopy(true);
  };

  const handleModalOpen = () => {
    setInstructionOpen(true);
  };

  const handleModalClose = () => {
    setInstructionOpen(false);
  };

  return (
    <Paper
      style={{
        width: '600px',
        height: '100%',
        maxWidth: 600,
        padding: '30px',
        boxShadow: 'none'
      }}
    >
      <Box
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}
      >
        <Box style={{ display: 'flex', alignItems: 'center' }}>
          <img
            alt="code"
            src={codeImg}
            style={{ width: 35, height: 35, marginRight: 15 }}
          />
          <div
            style={{
              fontFamily: 'Archivo',
              fontWeight: 700,
              fontSize: 21,
              color: '#19191A'
            }}
          >
            Get Code
          </div>
        </Box>
        <button
          onClick={props.handleClose}
          style={{ background: '#fff', border: 'none', cursor: 'pointer' }}
        >
          <img
            alt="close"
            src={closeButton}
            style={{ width: 14, height: 14 }}
          />
        </button>
      </Box>
      {process.env.NODE_ENV === 'development' ? (
        <Paper
          style={{
            maxWidth: 600,
            height: '300px',
            overflow: 'scroll',
            background: `${backgroundColor}`,
            color: `${textColor}`,
            boxShadow: 'none',
            padding: 20,
            marginTop: 10,
            marginBottom: 10,
            fontSize: 13,
            fontWeight: 500,
            fontFamily: 'Source Code Pro',
            whiteSpace: 'pre-wrap',
            overflowWrap: 'break-word'
          }}
        >
          {code}
        </Paper>
      ) : (
        <div>
          <img
            alt="codeCopy"
            src={codeCopy ? copied : copy}
            style={{ width: '100%', height: '100%' }}
          />
        </div>
      )}

      <Box
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginTop: 20
        }}
      >
        <button
          onClick={handleModalOpen}
          style={{
            color: 'black',
            textDecoration: 'underline',
            cursor: 'pointer',
            border: 'none',
            background: 'none'
          }}
        >
          Instruction
        </button>
        <CopyToClipboard text={obfuscation}>
          <button
            onClick={handleClick}
            style={{
              padding: '10px 30px',
              background: 'black',
              color: '#fff',
              fontWeight: 'bold',
              border: 'none',
              borderRadius: 4,
              cursor: 'pointer'
            }}
          >
            {codeCopy ? 'Copied' : 'Code Copy'}
          </button>
        </CopyToClipboard>
      </Box>
      <Dialog open={instructionOpen} maxWidth={false}>
        <InstructionModal handleClose={handleModalClose} />
      </Dialog>
    </Paper>
  );
};

export default GetCodeModal;
